import { Heading } from '@chakra-ui/layout'
import React, { FC } from 'react'

type Props = {
  title: string
  fontSize?: string
}

const BaseHeading: FC<Props> = ({ title, fontSize }) => {
  return (
    <Heading
      fontFamily="'Poppins', sans-serif"
      lineHeight="1.5"
      fontSize={fontSize || '1.6rem'}
      fontWeight="500"
      mb="1.4rem"
      color="brand.blue">
      {title}
    </Heading>
  )
}

export { BaseHeading }
